<template>
  <!-- Modal -->
  <div class="modal fade" data-backdrop="static" id="createNewCardModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Add new flashcard</h5>
          <button type="button" class="close" @click="cancelModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <form>
            <div class="form-group">
              <!-- <div class=""><label for="new-question" class="col-form-label">Question:</label></div> -->
              <h6>Question:</h6>
              <div class="markdown-checkbox">
                <input type="checkbox" class="form-check-input" ref="questionUsesMarkdown" id="questionUsesMarkdown">
                <label class="form-check-label" for="questionUsesMarkdown">Use Markdown</label>
              </div>
              
              <textarea class="form-control" rows="6" id="new-question" ref="newQuestion"></textarea>
            </div>
              <div class="form-group">
                <!-- <div class=""><label for="new-answer" class="col-form-label">Answer:</label></div> -->
                <h6>Answer:</h6>
                <div class="markdown-checkbox">
                  <input type="checkbox" class="form-check-input" ref="answerUsesMarkdown" id="answerUsesMarkdown">
                  <label class="form-check-label" for="answerUsesMarkdown">Use Markdown</label>
                </div>
                <textarea class="form-control" rows="6" id="new-answer" ref="newAnswer"></textarea>
              </div>
          </form>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancelModal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="saveModal">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import $ from 'jquery'

export default {
  name: 'AddFlashcardModal',
  props: ['collName', 'showAddFlashcardModal'],
  watch: {
    showAddFlashcardModal: function(newVal) {
      if (newVal) {
        $('#createNewCardModal').modal('show')
      } else {
        $('#createNewCardModal').modal('hide')
      }
      this.$refs.newQuestion.value = null
      this.$refs.newAnswer.value = null
    }
  },
  methods: {
    cancelModal: function(){
      this.$emit("cancelAddNewFlashcardModal")
    },
    saveModal: function(){
      this.$emit("saveAddNewFlashcardModal", {
        question: this.$refs.newQuestion.value,
        answer: this.$refs.newAnswer.value,
        questionUsesMarkdown: this.$refs.questionUsesMarkdown.checked,
        answerUsesMarkdown: this.$refs.answerUsesMarkdown.checked
      })
    }
  }
}
</script>

<style scoped>
  .modal-body {
    text-align: left;
  }
  .markdown-checkbox {
    padding-left: 1.25rem;
  }
  .form-check-label {
    margin-bottom: 0.5rem;
  }
</style>